import { createFileRoute } from "@tanstack/react-router";

import DailyPage from "@/admin/reports/daily/page";

export const Route = createFileRoute("/app/$storeId/reports/daily")({
    component: RouteComponent,
});

function RouteComponent() {
    return <DailyPage />;
}
